import { render } from "./modal-event-detail-tab.vue?vue&type=template&id=b0f41b94&scoped=true"
import script from "./modal-event-detail-tab.vue?vue&type=script&lang=js"
export * from "./modal-event-detail-tab.vue?vue&type=script&lang=js"

import "./modal-event-detail-tab.vue?vue&type=style&index=0&id=b0f41b94&lang=stylus&scoped=true"

import exportComponent from "/var/www/docker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b0f41b94"],['__file',"src/components/calendar/modal-event-detail/modal-event-detail-tab.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b0f41b94"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b0f41b94', __exports__)) {
    api.reload('b0f41b94', __exports__)
  }
  
  module.hot.accept("./modal-event-detail-tab.vue?vue&type=template&id=b0f41b94&scoped=true", () => {
    api.rerender('b0f41b94', render)
  })

}


export default __exports__